import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Checkbox } from "@/components/ui/checkbox";
import { Bell, Mail, Calendar } from "lucide-react";
import { toast } from "sonner";

const ROWS = [
  { key: "critical_email", icon: Mail, label: "Critical-pain email alerts",   sub: "Sent to your team staff email distribution list the moment a player logs pain or arm-health=1." },
  { key: "critical_inapp", icon: Bell, label: "In-app critical notifications", sub: "Red-badge bell in the coach header with a 14-day feed of CRITICAL events." },
  { key: "digest_email",   icon: Calendar, label: "Weekly Week-Ahead digest", sub: "Sunday 6 PM ET (or Monday 8 AM ET — see Digest schedule). Cc's the parent email on solo athletes." },
];

export default function NotificationPrefsCard() {
  const [prefs, setPrefs] = useState(null);

  useEffect(() => {
    api.get("/coaches/notification-prefs")
      .then(({ data }) => setPrefs(data.prefs))
      .catch((err) => { console.warn("[prefs] load failed:", err); setPrefs({ critical_email: true, critical_inapp: true, digest_email: true }); });
  }, []);

  const update = async (key, value) => {
    const next = { ...prefs, [key]: value };
    setPrefs(next);
    try { await api.put("/coaches/notification-prefs", { prefs: next }); }
    catch (err) {
      toast.error(formatApiError(err));
      setPrefs(prefs); // revert
    }
  };

  if (!prefs) return null;

  return (
    <section className="rounded-xl ink-card p-6" data-testid="notification-prefs-card">
      <div className="flex items-center gap-3">
        <Bell className="h-5 w-5" style={{ color: "var(--brand-secondary)" }} />
        <div>
          <h2 className="font-display font-bold text-lg text-white">My Notifications</h2>
          <p className="text-sm text-white/50 mt-0.5">Choose how you want to be alerted. Each staff role keeps its own preferences.</p>
        </div>
      </div>

      <ul className="mt-5 space-y-3">
        {ROWS.map((r) => {
          const Icon = r.icon;
          const checked = !!prefs[r.key];
          return (
            <li key={r.key} className="rounded-xl p-4 flex items-start gap-4" style={{ backgroundColor: "var(--ink-1)" }} data-testid={`notif-row-${r.key}`}>
              <div className="shrink-0 w-9 h-9 rounded-md flex items-center justify-center" style={{ backgroundColor: "rgba(255,255,255,0.05)" }}>
                <Icon className="h-4 w-4 text-white/75" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-display font-bold text-white text-sm">{r.label}</div>
                <p className="text-xs text-white/55 mt-1 leading-relaxed">{r.sub}</p>
              </div>
              <Checkbox
                checked={checked}
                onCheckedChange={(v) => update(r.key, !!v)}
                className="mt-1 border-white/30 data-[state=checked]:bg-[var(--brand-secondary)] data-[state=checked]:border-[var(--brand-secondary)]"
                data-testid={`notif-toggle-${r.key}`}
              />
            </li>
          );
        })}
      </ul>
    </section>
  );
}
